<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Sub Categories" title="Sub Categories" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-10 d-flex">
										<span style="font-size: 20px; font-weight: bolder;">Manage Sub Categories</span>
									</div>
									<div class="col-md-2">
										<button class="btn btn-primary" type="button" data-original-title="test" @click="openModal">Add Sub Category</button>
									</div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-6 d-flex">
										<label class="d-flex listing-length"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchCategories()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-3">
										<select class="form-select"  v-model="type" @change="fetchCategories()">
											<option :value="0">All Categories</option>
                                 			<option :value="type.id" v-for="type in types" :key="type.id">{{type.cat_name}}</option>
										</select>
									</div>
									<div class="col-md-3">
										<input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchCategories()" />
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr>
											<th>Image</th>
											<th>Name</th>
											<th>Category</th>
											<th>Category Type</th>
											<th>Status</th>
											<th>Options</th>
										</tr>
									</thead>
									<tbody v-if="Boolean(categories.length)">
										<tr v-for="cat in categories" :key="cat.id">
											<td><img :src="$image_url + cat.subcat_image" alt="Image not found" style="width:100px" /></td>
											<td>{{ cat.subcat_name }}</td>
											<td>{{ cat.category }}</td>
											<td>{{ cat.category_type }}</td>
											<td>
												<label v-if="cat.status == 1">Active</label>
												<label v-else>Blocked</label>
											</td>
											<td>
												<a class="btn btn-primary btn-sm mt-2 me-1" @click="editCategory(cat)">Edit</a>

												<a class="btn btn-danger btn-sm mt-2 me-1" @click="deactivateCategory(cat)" v-if="cat.status == 1">Deactivate</a>
												<a class="btn btn-success btn-sm mt-2 me-1" @click="activateCategory(cat)" v-else>Activate</a>

												<router-link :to="{name: 'sub_category_attributes', params: { id: cat.type_id,cat_id: cat.category_id, subcat_id:cat.id }}" class="btn btn-sm btn-primary mt-2 me-1" >Attributes</router-link>
											</td>
										</tr>
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="7" class="text-center">No data</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
										<a class="page-link" href="#" @click.prevent="fetchCategories(page.url + '&limit=' + listing_length + '&type=' + type + '&keyword=' + keyword)" tabindex="-1">
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->

						</div>

						<div class="modal fade" ref="cat-modal" id="cat-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
							aria-hidden="true">

							<div class="modal-dialog" role="document">
								<div class="modal-content">
									<div class="modal-header">
										<h5 class="modal-title" id="exampleModalLabel">Add Sub Category</h5>
										<button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
									</div>
									<div class="modal-body">
										
										<form @submit.prevent="addBrand" enctype="multipart/form-data">
											<div class="col-md-12 form-group">
												<label class="control-label">Category name <span class="required">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="category.cat_name" v-bind:class="{ 'is-invalid': Boolean(errors.name) }"/>
												<div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
													<p class="mb-0">{{ val }}</p>
												</div>
											</div>

											<div class="col-md-12 form-group mt-2">
												<label class="control-label">Category Type <span class="required">*</span></label>
												<select class="form-control" v-model="category.cat_type" v-bind:class="{ 'is-invalid': Boolean(errors.cat_type) }">
													<option :value="null" disabled>-- Select Type --</option>
													<option v-for="type in types" :key="type.id" :value="type.id">{{ type.cat_name }}</option>
												</select>
												<div v-for="(val, index) in errors.cat_type" :key="index" class="invalid-feedback">
													<p class="mb-0">{{ val }}</p>
												</div>
											</div>

											<div class="col-md-12 form-group mt-2">
												<label class="control-label">Category Image <span class="required">*</span> <span>[Allowed Formats: jpg, jpeg, png]</span></label>
												<div v-if="edit" class="form-group">
													<img v-bind:src="$image_url + category.cat_image" alt="Image not found" style="width:100px;" />
												</div>

												<input type="file" @change="setFile" accept="image/*" class="form-control image-class" v-bind:class="{ 'is-invalid': Boolean(errors.image) }" id="fileinput" />
												<div style="" v-if="edit">Leave this field empty if you don't want to change the image</div>
												<div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
													<p class="mb-0">{{ val }}</p>
												</div>
												<img class="image-preview" v-bind:src="preview_image">
											</div>

											<div class="col-md-12 mt-3 form-group">
												<button type="submit" class="btn btn-primary me-3" >{{ button_title }}</button>
												<button class="btn btn-light" @click="hideModal('brand-modal')">Close</button>
											</div>
										</form>

									</div>
									<!-- <div class="modal-footer">
										<button class="btn btn-primary" type="button" data-bs-dismiss="modal">Close</button>
										<button class="btn btn-secondary" type="button">Save changes</button>
									</div> -->
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>

		<DynamicModal ref="modal" :title="modal_title">
			<template #body>
				<form @submit.prevent="addCategory" enctype="multipart/form-data">
					<div class="col-md-12 form-group">
						<label class="control-label">Sub Category name <span class="required">*</span></label>
						<input class="form-control" type="text" placeholder="" v-model="category.subcat_name" v-bind:class="{ 'is-invalid': Boolean(errors.subcat_name) }"/>
						<div v-for="(val, index) in errors.subcat_name" :key="index" class="invalid-feedback">
							<p class="mb-0">{{ val }}</p>
						</div>
					</div>

					<div class="col-md-12 form-group mt-2">
						<label class="control-label">Category <span class="required">*</span></label>
						<select class="form-control" v-model="category.cat_type" v-bind:class="{ 'is-invalid': Boolean(errors.cat_name) }">
							<option :value="null" disabled>-- Select Category  --</option>
							<option v-for="type in types" :key="type.id" :value="type.id">{{ type.cat_name }}</option>
						</select>
						<div v-for="(val, index) in errors.cat_type" :key="index" class="invalid-feedback">
							<p class="mb-0">{{ val }}</p>
						</div>
					</div>

					<div class="col-md-12 form-group mt-2">
						<label class="control-label">Image <span class="required">*</span> <span>[Allowed Formats: jpg, jpeg, png]</span></label>
						<div v-if="edit" class="form-group">
							<img v-bind:src="$image_url + category.subcat_image" alt="Image not found" style="width:100px;" />
						</div>

						<input type="file" @change="setFile" accept="image/*" class="form-control image-class" v-bind:class="{ 'is-invalid': Boolean(errors.image) }" id="fileinput" />
							<div style="" v-if="edit">Leave this field empty if you don't want to change the image</div>
							<div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
								<p class="mb-0">{{ val }}</p>
							</div>
						<img class="image-preview" v-bind:src="preview_image">
					</div>

					<div class="col-md-12 form-group">
						<button type="submit" class="btn btn-primary me-3" >{{ button_title }}</button>
						<button type="button" class="btn btn-light" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>
		
	</div>
</template>


<script>

import { onMounted } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
	let dynamicmodal;

	export default {
		name: "CategoriesPage",
		components: {
			DynamicModal
		},
		setup(){
			onMounted(() => {
				dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
			})

			const showModal = () => {
				dynamicmodal.show();
			}

			const hideModal = () => {
				dynamicmodal.hide();
			}

			return {
				showModal, hideModal
			}
		},

		data() {
			return {
				categories: [],
				types: [],
				category: {
					id: null,
					subcat_name: "",
					cat_type: null,
					subcat_image: "",
				},
				image: '',
				preview_image: null,
				modal_title: "Add Category",
				button_title: "Add",
				pagination: {},
				edit: false,
				cat_status: {
					id: "",
					status: "",
				},
				keyword: "",
				showsearch: false,
				listing_length: 10,
				type: 0,
				token: "",
				errors: {},
				activate: false,
         		deactivate: false,

         		active_page_url: null,
			};
		},
		mounted() {
			//this.fetchSliders();
			//window.$('#datatable').DataTable();
		},

		created() {
			this.fetchCategories();
			this.fetchCategoryTypes();
		},

		methods: {
			fetchCategories(page_url = null) {
				let url = "/api/admin/subcategory?limit=" + this.listing_length + "&category=" + this.type + "&keyword=" + this.keyword;
				page_url = page_url || url;

				this.active_page_url = page_url;

				this.getToken();
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						this.categories = responseData.data;
						this.pagination = responseData.links;
						console.log(responseData);
					})
					.catch((err) => console.log(err));
			},

			fetchCategoryTypes() {
				this.getToken();
				this.$axios
					.get("/api/admin/subcategory/category", { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data;
						this.types = responseData.data;
						console.log(this.types);
					})
					.catch((err) => console.log(err));
			},

			openModal() {
				this.clearForm(); 
				this.modal_title = "Add Sub Category";
				this.button_title = "Add";
				this.showModal();
			},

			closeModal() {
				this.hideModal();
				 this.clearForm();
			},

			getToken() {
                if (localStorage.getItem('slo_admin')) {
                    var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
                    if(slo_admin.token) {

                        this.token = slo_admin.token;
                        this.user = slo_admin;

                    } else {
                        this.$swal("", "Failed to fetch token, please login again", "error");
                        this.$router.push({ name: "Login" });
                    }

                } else {
                    this.$swal("", "Session expired, please login again", "error");
                    this.$router.push({ name: "Login" });
                }
            },

			setFile(e) {
				this.image = e.target.files[0];
				this.preview_image = URL.createObjectURL(this.image);
			},

			addCategory() {
				this.getToken();
				let formData = new FormData();
				formData.append("name", this.category.subcat_name);
				formData.append("category", this.category.cat_type);
				formData.append("image", this.image);
				const config = {
					headers: {
						"content-type": "multipart/form-data",
						Authorization: "Bearer " + this.token,
					},
				};
				let url;
				if (!this.edit) {
					url = "/api/admin/subcategory/add";
					this.active_page_url = null;
				} else {
					url = "/api/admin/subcategory/edit";
					formData.append("subcat_id", this.category.id);
				}
				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.clearForm();
						this.closeModal();
						this.fetchCategories(this.active_page_url);
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								this.errors = error.response.data.message;
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

			showModal(modal) {
				this.$refs[modal].show();
			},

			hideModal(modal) {
				this.$refs[modal].hide();
			},

			editCategory(category) {
				this.edit = true;
				this.category.id = category.id;
				this.category.subcat_name = category.subcat_name;
				this.category.cat_type = category.category_id;
				this.category.cat_image = category.cat_image;
				this.errors = {};
				this.modal_title = "Edit Sub Category";
				this.button_title = "Update";
				this.showModal("");
			},
			clearForm() {
				this.edit = false;
				this.category.id = null;
				this.category.subcat_name = "";
				this.category.cat_type = null;
				this.category.cat_image = "";
				this.image = null;
				this.preview_image = null;
				this.modal_title = "Add Category";
				this.button_title = "Add";
				this.errors = {};
				document.getElementById('fileinput').value = '';
			},
			activateCategory(category) {
				this.activate = false;
				this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to activate this category?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.cat_status.id = category.id;
						this.cat_status.status = "1";
						this.updateCategoryStatus();
					}
					
				});
			},
			deactivateCategory(category) {
				this.deactivate = false;
				this.$swal({
					icon: 'warning',
					title:"Confirm",
					text:'Are you sure you want to deactivate this category?',
					showCancelButton: true,
					confirmButtonText: 'Yes',
					confirmButtonColor: '#e64942',
					cancelButtonText: 'No',
					position: "center",
					showConfirmButton: true,
					timer: '',
					toast: false,
					cancelButtonColor: '#efefef',
					}).then((result)=>{
					if(result.value){
						this.cat_status.id = category.id;
						this.cat_status.status = "0";
						this.updateCategoryStatus();
					}
				});
		        
			},
			updateCategoryStatus() {
				const config = {
					headers: {
						Authorization: "Bearer " + this.token,
					},
				};
				this.$axios
					.get("/api/admin/subcategory/status?subcat_id=" + this.cat_status.id + "&status=" + this.cat_status.status, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.fetchCategories(this.active_page_url);
					})
					.catch((error) => {
						if (error.response) {
							if (error.response.data.message) {
								this.$swal("", error.response.data.message, "error");
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},
		},
	};
</script>